





































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { UNIT_INVOICE_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitInvoiceSetting_currentUnit } from '@/queries/__generated__/unitInvoiceSetting';
import { IOverdueAction, IProcessOverdueNotice } from '@/app/overdue-notice-process';
import { GQL_emailInvoiceOverdueNotice } from '@/queries/__generated__/emailInvoiceOverdueNotice';
import InvoiceOverdueNoticesForm from './InvoiceOverdueNotices/InvoiceOverdueNoticesForm.vue';
import InvoiceOverdueNoticeMailButton from './InvoiceOverdueNotices/InvoiceOverdueNoticeMailButton.vue';

@Component({
  components: {
    InvoiceOverdueNoticesForm,
    InvoiceOverdueNoticeMailButton,
  },
})
export default class OverdueNoticeNextStep extends Vue {
  @Prop({ required: true }) private invoice!: {
    invoiceOverdueNotices: IProcessOverdueNotice[];
  };
  @Prop({ required: true }) private action!: IOverdueAction;

  @SmartQuery(UNIT_INVOICE_SETTINGS) private currentUnit!: GQL_unitInvoiceSetting_currentUnit;

  private get invoiceEmailCopy(): boolean {
    return !!this.currentUnit?.unitSetting?.unitInvoiceSetting?.invoiceEmailCopy;
  }

  // Writing a reminder is only half the step, so we take the user straight to
  // the mail dialog the reminder form's button is replaced by.
  private openMailDialog(): void {
    this.$nextTick(() => {
      (this.$refs.mailButton as InvoiceOverdueNoticeMailButton | undefined)?.open();
    });
  }

  // The list is queried without a cache, so the sent mail is recorded on the
  // notice here to move the invoice on to the step it now waits for.
  private noticeSent(data: GQL_emailInvoiceOverdueNotice): void {
    const logs = data.emailInvoiceOverdueNotice?.logInvoiceOverdueNoticeMail;

    if (!logs) return;

    this.$set(this.invoice, 'invoiceOverdueNotices', this.invoice.invoiceOverdueNotices.map(
      notice => notice.id !== this.action.noticeId ? notice : {
        ...notice,
        overdueNoticeLogs: (notice.overdueNoticeLogs || []).concat(logs),
      },
    ));
  }

  private get unsentNotice(): IProcessOverdueNotice | undefined {
    return this.invoice.invoiceOverdueNotices
      .find(notice => notice.id === this.action.noticeId);
  }

  private get actionLabel(): string {
    return this.$t(
      `Invoice.OverdueNotice.Process.Action.${this.action.type}`,
      {
        ordinal: this.$tc('ordinal', this.action.orderNumber || 1),
        date: this.action.availableFrom,
      },
    ) as string;
  }

  private get waitTitle(): string {
    return this.$t(
      'Invoice.OverdueNotice.Process.Action.waitTooltip',
      { date: this.action.availableFrom },
    ) as string;
  }
}
